// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2VVXQ","question":"Question_question__3z6Pb","description":"Question_description__Yub_q"};